import { AnyAction } from 'redux';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { IAppState } from '@ps20-frontend/apps/checkout-store';
import { CheckoutActions } from '../checkout.actions';
import { PoliceVersand, PoliceVersandArtEnum } from '../model/policeVersandArt';
import { isVertreter } from '../selector/role.selector';
import { selectPossibleVersandArten } from '../selector/policeVersand.selector';

export const policeVersandReducer = function (
  sectionState: PoliceVersand = null,
  action: AnyAction,
  appState: IAppState,
): PoliceVersand {
  switch (action.type) {
    case CheckoutActions.CHANGE_POLICE_VERSAND_ART: {
      const versandArt: PoliceVersandArtEnum = action.payload;
      return { ...sectionState, versandArt };
    }
    case GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL: {
      const newState = { ...sectionState };
      if (isVertreter(appState) && sectionState.versandArt == null) {
        newState.versandArt = PoliceVersandArtEnum.DIGITAL_VOLL_POLICE;
      }
      const possibleVersandArten = selectPossibleVersandArten(appState);
      if (possibleVersandArten.length === 1) {
        newState.versandArt = possibleVersandArten[0];
      }
      return newState;
    }
    default:
      return sectionState;
  }
};
